import { useState } from "react";

export type ValidationType = "none" | "len4" | "len8" | "len10" | "email";


const isInvalidFunc = (type: ValidationType, value: string) => {


    if (type === "none") {
        return true;
    } else if (type === "len4") {
        return (value?.length ?? 0) < 4;
    } else if (type === "len8") {
        return (value?.length ?? 0) < 8;
    } else if (type === "len10") {
        return (value?.length ?? 0) < 10;
    } else if (type === "email") {
        let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const len = (value?.length ?? 0) > 5;
        const hasAt = value?.includes("@");
        const r = regex.test(value);
        return !(len && hasAt && r);
    }



    return true;
}


export const useFormValidation = (formName: string) => {
    const [isMandatoryStore, setIsMandatoryStore] = useState<{ [id: string]: { value: string, isMandatory: boolean } }>({});
    const [registers, setRegisters] = useState<{ [id: string]: ValidationType }>({});
    const [isInvalid, setIsInvalid] = useState<{ [x: string]: boolean }>({});

    return {
        initializeForm: () => {
            console.log("Form initialize:", formName, "registers: ", registers, isMandatoryStore);
        },
        register: (id: string, type: ValidationType, onChange: (e: string) => void, isMandatory?: boolean, errorMessage?: string) => {
            if (!registers[id]) {
                setRegisters({ ...registers, [id]: type });
                setIsMandatoryStore({ ...isMandatoryStore, [id]: { value: "", isMandatory: !!isMandatory } })
            }

            return {
                onChange: (e: string) => {
                    onChange(e);
                    // Field i invalid
                    const _isInvalid = { ...isInvalid, [id]: isInvalidFunc(type, e) };
                    setIsInvalid(_isInvalid);
                    const _isMandatoryStore = { ...isMandatoryStore, [id]: { value: e, isMandatory: isMandatoryStore?.[id].isMandatory } };
                    setIsMandatoryStore(_isMandatoryStore);
                },
                invalid: !!isInvalid[id] === true,
                errorMessage: !!isInvalid[id] === true ? errorMessage : ""
            }
        },
        formIsValid:
            /* None is invalid*/
            Object.keys(isInvalid)
                .map(key => isInvalid[key])
                .filter(fieldisInvalid => fieldisInvalid === true)
                .length === 0 &&
            /* Check mandatory */
            Object.keys(isMandatoryStore)
                .map(key => isMandatoryStore[key])
                .filter(m => m.isMandatory == false || !m.value)
                .length == 0,
    }
}